module.exports = __webpack_public_path__ + "static/media/Korg-N1R-Pedal-Hi-Hat.b59ebe0f.wav";